module.exports = __webpack_public_path__ + "static/media/tax_banner.6d6450ae.svg";